import React from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import ReportPage from './pages/ReportPage';
import ConfirmationPage from './pages/ConfirmationPage';
import LandingPage from './pages/LandingPage';
import { Providers } from './components/providers';

interface IApp {}

export const App = (props: IApp) => {
	return (
		<Providers>
			<BrowserRouter>
				<Routes>
					<Route path='/confirmation' element={<ConfirmationPage />} />
					<Route path='/report' element={<ReportPage />} />
					<Route path='/' element={<LandingPage />} />
				</Routes>
			</BrowserRouter>
		</Providers>
	);
};
